import $ from 'jquery';
import { SITE_HOST } from './consts';

// Private
const lowercaseObjectValues = obj => Object.keys(obj).reduce((lowercasedObj, key) => {
  lowercasedObj[key] = obj[key] ? obj[key].toLowerCase() : null;
  return lowercasedObj;
}, {});


// Public
export const isServer = (typeof (window) === 'undefined');

export const fetchData = async (fetchPath) => {
  const completePath = `${SITE_HOST}${fetchPath}`;

  return await fetch(completePath, {
    headers: {
      Accept: 'application/json',
    },
  }).then(data => data.json());
};

export const topOfPage = () => {
  try {
    window.scrollTo(0, 0);
  } catch (e) {

  }
};

export const scrollToTopOf = (element, offset = 0, speed = 400, callback = () => { }) => {
  console.log("trying to scroll")
  $('html, body').animate({
    scrollTop: $(element).offset().top - (offset + 15),
  }, speed, 'swing', callback);
};

export const convertHexToRGBA = (hex, alpha = 1) => {
  const r = parseInt(hex.slice(1, 3), 16);


  const g = parseInt(hex.slice(3, 5), 16);


  const b = parseInt(hex.slice(5, 7), 16);

  return `rgba(${r},${g},${b},${alpha})`;
};

// modified copy of same function from Helmet source code
export const encodeSpecialCharacters = (str) => {
  return String(str)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#x27;");
};

export const encodeHTML = html => {
  if (!html || (typeof html === "string" && html.length === 0)) {
    return "";
  }

  return html.replace(/[\u00A0-\u9999<>\&]/gim, i => `&#${i.charCodeAt(0)};`);
}

export const encodeTitle = (str) => {
  if (str.indexOf("'") !== -1 || str.indexOf('"') !== -1) {
    return encodeHTML(str);
  }
  else {
    return encodeSpecialCharacters(str);
  }
}


export const decodeHTML = str => str.replace(/&#(\d+);/g, (match, dec) => String.fromCharCode(dec));

export const decodeTags = str => str.replace(/&lt;/g, '<').replace(/&gt;/g, '>');

//decodes special characters in strings for metadata - add new characters as needed
export const decodeEntities = (str) => {
  if (str && typeof str === 'string') {
    let strng = str;
    if (str.match('&eacute;')) {
      strng = str.replace('&eacute;', 'e');
    }
    return strng;
  }
  return str;
};

export const toggleScrollLock = () => {
  const bodyClass = document.body.classList;

  if (bodyClass.contains('lock')) {
    bodyClass.remove('lock');
  } else {
    bodyClass.add('lock');
  }
};

// track Segment Page event
export const segmentTrackPage = (title, baseTracker = {}) => {
  const formattedTracker = lowercaseObjectValues({
    ...baseTracker,
    title,
    path: location.pathname,
    url: location.href,
    referrer: document.referrer,
    search: location.search,
  });
  analytics.page(title, formattedTracker);
};

// track Segment Page event within single url (receives url property via baseTracker)
export const segmentTrackComponentAsPage = (baseTracker = {}) => {
  const formattedTracker = lowercaseObjectValues({
    ...baseTracker,
    title: document.title,
    path: location.pathname,
    referrer: document.referrer,
    search: location.search,
  });
  analytics.page(formattedTracker);
};

// track Segment events that are not Page
export const segmentTrackEvent = (eventName, eventSpecific, baseTracker = {}) => {
  console.log("tracking : ", eventName);
  const tracker = lowercaseObjectValues({ ...baseTracker, ...eventSpecific });
  analytics.track(eventName, lowercaseObjectValues(tracker));
};

export const getFileName = (src) => {
  const match = src.match(/[^/\\]+(?:jpg|jpeg|png|svg)/);
  return match ? match[0].replace(/(%20|-|_)/g, ' ').replace(/\.(jpg|jpeg|png|svg)/, '') : null;
};

export const getSocialDisplay = (handle) => {
  if (handle.match("/")) {
    let display = handle.split("/")[0];
    return display;
  }
  return handle;
};

/*
this same function exists in server/transform.js. however, we've duplicated it here for now because
there is a known issue w/ importing and exporting modules between server/ and src/ which will be addressed
in the future (most likely something in the webpack setup).
*/
export const getProperty = (iterable, props = [], cb) => {
  const currentProp = iterable[props.shift()];

  if (typeof currentProp === 'undefined' || !currentProp || currentProp.length === 0) {
    return null;
  }

  if (props.length === 0) {
    return cb ? cb(currentProp) : currentProp;
  }

  return getProperty(currentProp, props, cb);
};

export const getArticleModulesWithAds = (modules, aritcleID, appEnv, articleType) => {
  // the ad-inserting logic can be a component method.
  const modulesNoSub = modules.filter(item => item.type !== 'sub-head');
  const numOfModulesNoSub = modulesNoSub.length;
  let adCount = 1;
  let ad = {};

  // Insert ads if more than 4 modules (not including sub-heads)
  if (!(modules.some(module => module.type === 'ad'))) {
    if (numOfModulesNoSub > 4) {
      let index = 4;
      // Ads will appear after every 4 modules (not including sub-heads)
      while (index <= modules.length) {
        // increase index position each time there is a sub-head in prior 4 modules
        for (let x = 4; x > 0; x -= 1) {
          if (modules[index - x].type === 'sub-head' && index + 1 <= modules.length) {
            x += 1;
            index += 1;
          }
        }
        ad = {
          type: 'ad',
          data: {
            slot_name: `article_slot_${adCount}`, id: aritcleID, env: appEnv, type: articleType,
          },
        };
        modules.splice((index), 0, ad);
        adCount += 1;
        index += 5;
      }
      // if less than or equal to three modules (not including sub-heads)
    } else {
      ad = {
        type: 'ad',
        data: {
          slot_name: `article_slot_${adCount}`, id: aritcleID, env: appEnv, type: articleType,
        },
      };
      modules.push(ad);
    }
  }
  const adLength = adCount >= 3 ? 'long' : 'short';
  modules.map(module => (module.type === 'ad' ? module.data.length = adLength : null));
  return modules;
};

export const getArticleLength = (modules) => {
  const firstAd = modules.find(module => module.type === 'ad');
  const { length } = firstAd.data;
  return length;
};

export const getRecirculationData = async () => {
  const data = await fetchData('/api/home');
  return data.articles;
};

export const makeStaticAdsResponsive = (slotFrame, slotImg, id) => {
  const handleResize = () => {
    const imgHeight = slotImg.clientHeight;
    if (imgHeight != 0) {
      slotFrame.style.height = imgHeight + "px";
    }
  }

  if (slotImg && !slotImg.src.includes("celtra")) {
    slotImg.style.height = "auto";
    slotImg.style.width = "100%";
    if (slotImg.clientHeight != 0) {
      slotFrame.style.height = slotImg.clientHeight + "px";
    }
    else {
      setTimeout(handleResize, 500);
    }
    window.addEventListener('resize', handleResize);
  }
}

export const sendLog = (component, level, message) => {
  const codedMessage = message.replace(/ /g, '-');
  const fetchURL = `${SITE_HOST}/log/${component}/${level}/${codedMessage}`;
  fetch(fetchURL, {
    headers: {
      Accept: 'application/json',
    },
  }).then((res) => console.log('SRC response:', res.status))
    .catch(rejected => {
      console.log('NOPE:', rejected);
    });
};

export const gaTrackEvent = (el) => {
  const category = el.getAttribute('data-gae-category');
  const action = el.getAttribute('data-gae-action');

  GoogleTrackEventLinkClick(category, action, el);
}

//GA Start (from WOW)
function GoogleTrackEventIntraPageNonInteractive(category, action, label) {
  if (typeof (window.snowplow) != "undefined") {
    window.snowplow('trackStructEvent', category, action, label, 'nonInteraction', 0);
  }

  // we only include the GA code in production
  if (typeof (ga) == "undefined") {
    console.log('GoogleTrackEventIntraPageNonInteractive: bail');
    return;
  }

  ga('send', 'event', category, action, label, 0, { nonInteraction: true });
}

function GoogleTrackEventIntraPage(category, action, label, value) {

  if (typeof (window.snowplow) != "undefined") {
    window.snowplow('trackStructEvent', category, action, label, '', value);
  }

  // we only include the GA code in production
  if (typeof (ga) == "undefined") {
    console.log('GoogleTrackEventIntraPage: bail');
    return;
  }

  ga('send', 'event', category, action, label);


}

function GoogleQueueTrackSocial(gaCategory, gaAction, gaLabel) {

  // going to perform below inside component code.
  // if (typeof(window.analytics) != "undefined") 
  // {
  //  analytics.ready(function() {
  //    var currentUrl = window.location.href;
  //    var element = $(this).attr('class');
  //    var location = $(this).attr('data-gae-event-category');
  //    var position = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);    
  //    var origSegmentObj = {
  //      current_url: currentUrl,
  //      action_type: gaCategory,
  //      location: location,
  //      element: gaLabel,
  //      position: position,
  //      standardSegmentParameters: standardSegmentParameters        
  //    }
  //    var flattenedObj = flattenObject(origSegmentObj);

  //    analytics.track('article_shared', flattenedObj);
  //  });
  // }

  // we only include the GA code in production
  if (typeof (ga) == "undefined") {
    console.log('GoogleQueueTrackSocial: bail');
    return;
  }

  ga('send', 'social', gaCategory, gaAction, gaLabel);
}

// going to perform below inside component code.
// function TrackEventAffiliateClick(linkObject)
// {
//  if (typeof(window.analytics) != "undefined") 
//  {
//    analytics.ready(function() {

//      var current_url = window.location.href;
//      var element = $(linkObject).attr('class');
//      var destination_url = linkObject.href;
//      var vendor = getVendorFromUrl(destination_url, linkObject);
//      //Slideshow number
//      var position = window.location.href.substr(window.location.href.lastIndexOf('/') + 1);    
//      var merchant = $(linkObject).attr("data-gae-merchant") ;
//      var item = $(linkObject).attr("data-gae-item");
//      var img = $(linkObject).find('img').attr('src');
//      var input_method = 'programmatic';
//      if(merchant || item) {
//        input_method = 'CMS';
//      }
//      var origSegmentObj = {
//        current_url : current_url,
//        destination_url : destination_url,
//        element : element,
//        image_id : img,
//        position : position,
//        merchant : merchant,
//        item : item,
//        vendor : vendor,
//        input_method : input_method,
//        standardSegmentParameters: standardSegmentParameters
//      }
//      var flattenedObj = flattenObject(origSegmentObj); 

//      //Only track these 3 vendors 11/13/17 (PBED-339)
//      if(vendor == 'Skimlinks' || vendor == 'Amazon' || vendor == 'Narrativ' || vendor == 'VigLink' ) {
//        console.log('TrackEventAffiliateClick: href:' + destination_url);
//        //console.log(window.PureWowNS.segmentPageInfo);
//        analytics.track('Affiliate Clicked', flattenedObj);
//      }
//    });
//  }
// }

function GoogleTrackEventLinkClick(defaultCategory, defaultAction, linkObject, entryTypeId) {
  // we'll look for some specific values in the "gae" attributes of the link object,
  // but we'll use the input values if specific values do not exist
  var category = defaultCategory;
  var action = defaultAction;
  var label = linkObject.href;
  var nonInteractive = "false";
  var trackType = "event";
  var rawHref = $(linkObject).attr('href');   // linkObject.href always returns the complete URL; $(linkObject).attr('href') returns exactly what's in the HTML

  if ($(linkObject).attr("gae_category") !== undefined) {
    category = $(linkObject).attr("gae_category");
  }
  if ($(linkObject).attr("gae_action") !== undefined) {
    action = $(linkObject).attr("gae_action");
  }
  if ($(linkObject).attr("gae_label") !== undefined) {
    label = $(linkObject).attr("gae_label");
  }

  // 02/2014: changed to these attribute names
  if ($(linkObject).attr("data-gae-category") !== undefined) {
    category = $(linkObject).attr("data-gae-category");
  }
  if ($(linkObject).attr("data-gae-action") !== undefined) {
    action = $(linkObject).attr("data-gae-action");
  }
  if ($(linkObject).attr("data-gae-label") !== undefined) {
    label = $(linkObject).attr("data-gae-label");
    if (label == 'none') {
      label = '';
    }
  }
  if ($(linkObject).attr("data-gae-non-interactive") !== undefined) {
    nonInteractive = $(linkObject).attr("data-gae-non-interactive");
  }

  if ($(linkObject).attr("data-gae-track") !== undefined && $(linkObject).attr("data-gae-track") == 'social') {
    trackType = "social";
  }

  if (trackType == 'social') {
    GoogleQueueTrackSocial(category, action, label);
    // 05/20/2014: We also want a non-social GA event in some cases
    // var addedGaEvent       = false;
    var addedGaEventCategory = category;
    var addedGaEventAction = action;
    var addedGaEventLabel = label;

    // Sometimes we want to have more control over the GA events instead of just the fixed
    // values above. In those cases, we use a secondary attribute: data-gae-event-category
    if ($(linkObject).attr("data-gae-event-category") !== undefined) {
      addedGaEventCategory = $(linkObject).attr("data-gae-event-category");
      if ($(linkObject).attr("data-gae-action") !== undefined) {
        addedGaEventAction = $(linkObject).attr("data-gae-action");
      }
      if ($(linkObject).attr("data-gae-label") !== undefined) {
        addedGaEventLabel = $(linkObject).attr("data-gae-label");
        if (addedGaEventLabel == 'none') {
          addedGaEventLabel = '';
        }
      }
    }

    if (addedGaEventAction != 'none') {
      GoogleTrackEventIntraPage(addedGaEventCategory, addedGaEventAction, addedGaEventLabel);
    }

    return;
  }
  // doesn't apply to cocktails
  // else if ($(linkObject).attr("data-gae-merchant") || $(linkObject).attr("data-gae-item") )
  // {
  //  //Dont fire this with the regular events
  //  //Affiliate articles have a Merchant and Item attribute that we will pass in as their own event
  //  var affiliateLabel = $(linkObject).attr("data-gae-merchant") + '_' + $(linkObject).attr("data-gae-item");
  //  GoogleTrackEventIntraPage('affiliate_links', linkObject.hostname, affiliateLabel);
  //  if(typeof _new_affiliate_tracking === 'undefined' || ! _new_affiliate_tracking) {
  //    TrackEventAffiliateClick(linkObject);
  //  }
  // }
  else {
    // regular non-social path
    if (nonInteractive == "true") {
      GoogleTrackEventIntraPageNonInteractive(category, action, label);
    }
    else {
      GoogleTrackEventIntraPage(category, action, label);
    }
  }

  // doesn't apply to cocktails
  // If this is an affiliate article special tracking is needed for affiliate links within article
  // if(typeof _new_affiliate_tracking !== 'undefined' && _new_affiliate_tracking) {
  //  if(typeof entryTypeId !== 'undefined' && entryTypeId == '3' && trackType != 'social' && nonInteractive == 'false')
  //  {
  //    TrackEventAffiliateClick(linkObject);
  //  }
  // }

  // Sometimes we just record Javascript handled events like intrapage prev/next slide actions.
  // Those always start with #
  if (rawHref == undefined) {
    return true;
  }

  if ((rawHref.charAt(0) == '#')) {
    return true;
  }

  var opensInNewWindow = false;
  if (linkObject.target) {
    if (linkObject.target.toLowerCase() == '_blank') {
      opensInNewWindow = true;
    }
  }

  if (opensInNewWindow == true) {
    return true;
  }

  // see: http://support.google.com/googleanalytics/bin/answer.py?hl=en&answer=55527
  setTimeout('document.location = "' + linkObject.href + '"', 100);

  return false;
}
//GA End (from WOW)

export const createGATags = (category, action, label) => {
  return {
    "data-gae-track": "event",
    "data-gae-category": category,
    "data-gae-action": action,
    "data-gae-label": label
  };
};

export const handleEventTrack = (e) => {
  let el = e.currentTarget;
  let action = el.getAttribute('data-gae-action');
  let category = el.getAttribute('data-gae-category');
  GoogleTrackEventLinkClick(category, action, el);

};





// NOTE ON COOKIES:
// we're doing combination cookies + jwTokens because universal apps aren't
// single page apps (SPAs). Server-rendered requests, when triggered via
// direct visits by the user, do not have headers we can set. That's the
// takeaway.
